// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-live-reservation-hsylc[data-v-314032f1] {\n  width: 100%;\n  max-width: 750px;\n  margin: 0 auto;\n}\n.page-live-reservation-hsylc img[data-v-314032f1] {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n", ""]);
// Exports
module.exports = exports;
